export default "__VITE_ASSET__BYR2kkAN__"